/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Container,
  Divider,
} from '@mui/material';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import Images from '../../../../Configs/images';
// import ROUTES from '../../../../Configs/routes';
import { getNotifications } from '../../../../Redux/Models/notification';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import Colors from '../../../../Configs/colors';

const types = [
  'All',
  'Request In',
  'Request Out',
  'Subscription',
  'Market',
];

export default function Notifications({
  classes, error, message, data, isLoading, currentPage, totalPage,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = getUserData();

  const { openAlert } = useContext(AlertContext);

  const [items, setItems] = useState([]);
  const [type, setType] = useState('All');
  const [page, setPage] = useState(1);
  const { t } = useTranslation();

  const getData = () => {
    dispatch(getNotifications(user.id, { type: type === 'All' ? '' : type, page }));
  };

  useEffect(() => {
    if (currentPage > 1) {
      setItems([...items, ...data]);
    } else if (currentPage === 1) {
      setItems(data);
    }
  }, [currentPage, data]);

  const loadMore = () => {
    setPage((p) => p + 1);
  };

  useEffect(() => {
    if (page === 1) {
      getData();
    } else {
      setPage(1);
    }
  }, [type]);

  useEffect(() => {
    getData();
  }, [page]);

  useEffect(() => {
    if (error) {
      openAlert({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const handleClickNotif = (notif) => {
    if (notif.type === 'Market') {
      navigate(`${ROUTES.market()}/search/${notif.item_id}`);
    } else if (notif.type?.includes('Request')) {
      navigate(`${ROUTES.history()}/${notif.request_id}`);
    } else if (notif.type?.includes('Subs')) {
      navigate(`${ROUTES.mySubscription()}`);
    }
  };

  return (
    <Elements.PageBase navigate={navigate}>
      <div className={classes.root}>
        <Box className="sticky" sx={{ pt: 2, bgcolor: '#fff' }}>
          <Container>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <h4>{t('notificationPage.title')}</h4>
              {/* <div className="mute s-12">Mark all as read</div> */}
            </Box>

            <Box
              gap={0.5}
              className="flex align-items-center"
              flexWrap="nowrap"
              overflow="auto"
              mt={1}
              mb={2}
              sx={{
                '::-webkit-scrollbar': {
                  display: 'none',
                },
                '-ms-overflow-style': {
                  display: 'none',
                },
                scrollbarWidth: 'none',
              }}
            >
              {types.map((ty) => (
                <Box
                  key={ty}
                  sx={{ whiteSpace: 'nowrap' }}
                  border="1px solid #ccc"
                  px={1}
                  py={0.5}
                  borderRadius={2}
                  className="s-14 weight-600 link"
                  bgcolor={type === ty ? Colors.primary : 'transparent'}
                  color={type === ty ? '#fff' : '#000'}
                  onClick={() => {
                    setItems([]);
                    setType(ty);
                  }}
                >
                  {ty}
                </Box>
              ))}
            </Box>
          </Container>
          <Divider />
        </Box>

        <Box py={1} px={2}>
          <InfiniteScroll
            next={loadMore}
            hasMore={Boolean(totalPage > currentPage)}
            dataLength={items.length}
          >
            {items.map((item) => (
              <Box key={item.date} mb={2}>
                <div className="weight-700 s-14">{item.date}</div>
                {item.notification.map((notif) => (
                  <Box display="flex" gap={1} alignItems="flex-start" mt={1} key={notif.id} className="link" onClick={() => handleClickNotif(notif)}>
                    <img
                      src={notif.type === 'Request In'
                        ? Images.OenoIn : notif.type === 'Request Item'
                          ? Images.OenoMarket : Images.OenoOut}
                      height="12"
                      width="12"
                      alt={notif.type}
                      style={{ marginTop: 1 }}
                    />
                    <Box width="100%">
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box className="s-10 weight-600">{notif.type}</Box>
                        <Box className="s-10 mute">{moment(new Date(notif.created_at)).format('hh:mmA')}</Box>
                      </Box>
                      <Box className="s-12 weight-700" mt={0.25}>{notif.title}</Box>
                      <Box className="s-12">{notif.short_message}</Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            ))}
            {isLoading && 'loading...'}
            {!isLoading && !items.length && 'There is no notification'}
          </InfiniteScroll>
        </Box>
      </div>
    </Elements.PageBase>
  );
}
